import { render } from "./user_activity_logs.html?vue&type=template&id=5a35c902&external"
import script from "./user_activity_logs.js?vue&type=script&lang=js&external"
export * from "./user_activity_logs.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__